import api from './api';

export const createBOMItem = async (bomData) => {
  const response = await api.post('/bom/', bomData);
  return response.data;
};

export const getBOMByProject = async (projectId) => {
  const response = await api.get(`/bom/project/${projectId}`);
  return response.data;
};

export const getProjectBudget = async (projectId) => {
  const response = await api.get(`/bom/project/${projectId}/budget`);
  return response.data;
};

export const getBOMById = async (bomId) => {
  const response = await api.get(`/bom/${bomId}`);
  return response.data;
};

export const updateBOMItem = async (bomId, bomData) => {
  const response = await api.put(`/bom/${bomId}`, bomData);
  return response.data;
};

export const deleteBOMItem = async (bomId) => {
  const response = await api.delete(`/bom/${bomId}`);
  return response.data;
};

export const getAllPendingBOM = async () => {
  const response = await api.get('/bom/pending');
  return response.data;
};

export const markBOMOrdered = async (bomId) => {
  const response = await api.patch(`/bom/${bomId}/order`);
  return response.data;
};